import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mine-down",
  "use": "icon-mine-down-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol fill=\"currentColor\" class=\"\" viewBox=\"0 0 12 7\" id=\"icon-mine-down\">\n  <path id=\"icon-mine-down_d1934cbc7e9a2f62df9c0f98cbc22c3d-icon_top_arrow\" d=\"M300.734,37.264A1,1,0,0,0,300,37l-9.973.066a1,1,0,0,0-.731.264.953.953,0,0,0,0,1.387l4.986,4.953c.067.066.2.132.266.2l.067.066a1.045,1.045,0,0,0,1.063-.2l4.987-5.019A1.036,1.036,0,0,0,300.734,37.264Z\" transform=\"translate(-289 -37)\" />\n\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol